import React, { useEffect, useState, useCallback } from "react";
import styled from "styled-components";
import Pikaday from "pikaday";
import logger from "utils/logger";
import { formatTime } from "utils/date";

const StyledInput = styled.input`
  appearance: none;
  height: 100%;
  display: block;
  outline: none;
  border: 1px solid ${({ theme }) => theme.borderGray};
  color: ${({ theme }) => theme.black};
  width: 100px;
  text-align: center;
  font-size: ${({ theme }) => theme.fontSize.lsmall};

  ::placeholder {
    font-size: ${({ theme }) => theme.fontSize.small};
  }
`;

const DatePicker = ({
  id = 1,
  placeholder = "选择日期",
  date = null,
  setDate = (v) => logger.log(v),
}) => {
  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const picker = new Pikaday({
      field: document.getElementById(`datepicker${id}`),
      keyboardInput: false,
      firstDay: 1,
      yearRange: [currentYear - 40, currentYear + 10],
      onSelect: (date) => {
        setDate(date);
      },
      i18n: {
        previousMonth: "上个月",
        nextMonth: "下个月",
        months: [
          "1月",
          "2月",
          "3月",
          "4月",
          "5月",
          "6月",
          "7月",
          "8月",
          "9月",
          "10月",
          "11月",
          "12月",
        ],
        weekdays: [
          "星期天",
          "星期一",
          "星期二",
          "星期三",
          "星期四",
          "星期五",
          "星期六",
        ],
        weekdaysShort: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      },
    });
    logger.log(picker);
  }, []);
  return (
    <StyledInput
      id={`datepicker${id}`}
      type="text"
      value={formatTime("yyyy-MM-dd", date)}
      onChange={(e) => logger.log("选择日期", e)}
      autoComplete="off"
      placeholder={placeholder}
    ></StyledInput>
  );
};

export default DatePicker;
